module.exports = __webpack_public_path__ + "img/success-status.2b465c37.svg";